export const environment = {
    production: false,
    VERSION: '1.0.0',
    GOOGLE_CLIENT_ID: '604585722098-rqu5sum6i5mo54ca93tumqrbv8865cc8.apps.googleusercontent.com',

    // DEVELOP
    // ng serve
    // ng build --configuration=development
    // this file is the one used in develop (fileReplacements)

    // LOCAL API
    // URL_API_PEDIDOS: 'http://localhost:5000',

    // CLOUD API (develop)
    URL_API_PEDIDOS: 'https://pedidosdev.zeymdevtools.lat',
};
